import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'

import PaginationComponent from 'components/Atoms/Pagination'

const Pagination = ({
  currentPage,
  loadMore,
  moreResultsAvailable,
  pageCount,
  setIsLoading,
}) => {
  const handleOnClick = (e, page) => {
    e.preventDefault()

    setIsLoading(true)

    loadMore(page)
  }

  return (
    <PaginationComponent
      currentPage={currentPage}
      moreResultsAvailable={moreResultsAvailable}
      onClick={handleOnClick}
      pageCount={pageCount}
    />
  )
}

Pagination.propTypes = {
  currentPage: PropTypes.number,
  loadMore: PropTypes.func,
  moreResultsAvailable: PropTypes.bool,
  pageCount: PropTypes.number,
  setIsLoading: PropTypes.func,
}

export default withRouter(Pagination)
